<template>
  <HomeLayout v-if="offlineConfirmed">
    <div class="w-full flex items-center h-full">
      <div class="w-full">
        <h1 class="text-white text-lg sm:text-xl">
          해당 페이지를 불러올 수 없습니다. <br />
          인터넷에 접속되어 있나 확인 바랍니다.
        </h1>
      </div>
    </div>
  </HomeLayout>
  <LoadingView v-else />
</template>

<script>
import axios from 'axios'
import HomeLayout from '@layouts/home-layout.vue'
import LoadingView from './_loading.vue'

export default {
  components: { HomeLayout, LoadingView },
  data() {
    return {
      offlineConfirmed: false,
    }
  },
  beforeCreate() {
    axios
      .head('/api/ping')
      .then(() => {
        window.location.reload()
      })
      .catch(() => {
        this.offlineConfirmed = true
      })
  },
}
</script>
